import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.small.js";
import _fillInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/fill";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useRef } from "react";
import { RaiseColors, Typography, makeStyles, useTheme, useMediaQuery, TextField } from "componentLibrary";
import RaiseButton, { ButtonVariantEnum, ButtonSizeEnum } from "componentLibrary/MuiComponentWrappers/Button/RaiseButton";
import TextLink from "componentLibrary/TextLink/TextLink";
import { WorkplaceOSLoginContainer, WorkplaceOSLoginHeader, WorkplaceOSLoginTerms } from "./WorkplaceOSLoginCommon";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    instructionText: {
      marginBottom: "24px",
      color: RaiseColors.grayscale900
    },
    otpContainer: _defineProperty({
      display: "flex",
      flexDirection: "row",
      marginBottom: "24px",
      gap: "24px"
    }, theme.breakpoints.down("smMd"), {
      gap: "16px"
    }),
    otpInput: _defineProperty({
      width: "53px",
      height: "60px"
    }, theme.breakpoints.down("smMd"), {
      flex: "1 1 0",
      minWidth: 0,
      height: "40px"
    }),
    otpInputRoot: {
      backgroundColor: RaiseColors.grayscale200,
      borderRadius: "4px",
      height: "100%",
      border: "none",
      "&::after": {
        border: "none",
        display: "none"
      },
      "&::before": {
        border: "none",
        display: "none"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none"
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none"
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none"
      }
    },
    otpInputInner: _defineProperty({
      textAlign: "center",
      padding: "0px",
      height: "100%",
      fontSize: "20px",
      lineHeight: "28px",
      letterSpacing: "-0.32px",
      fontWeight: 600,
      color: RaiseColors.midnight
    }, theme.breakpoints.down("smMd"), {
      fontSize: "14px",
      lineHeight: "20px"
    }),
    errorMessage: {
      marginBottom: "24px",
      marginTop: "-8px"
    },
    signInButton: {
      width: "100%",
      marginBottom: "24px",
      "& button": _defineProperty({
        height: "48px"
      }, theme.breakpoints.down("smMd"), {
        height: "40px"
      })
    },
    resendSection: _defineProperty({
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    }, theme.breakpoints.down("smMd"), {
      flexDirection: "row",
      gap: "4px",
      alignItems: "center"
    }),
    resendText: {
      color: RaiseColors.grayscale900
    }
  };
});
var NUM_OTP_DIGITS = 6;
var WorkplaceOTPVerification = function WorkplaceOTPVerification(_ref) {
  var _context;
  var email = _ref.email,
    onBack = _ref.onBack,
    onVerifyOTP = _ref.onVerifyOTP,
    onResendOTP = _ref.onResendOTP,
    loading = _ref.loading,
    isError = _ref.isError,
    errorMessage = _ref.errorMessage;
  var classes = useStyles();
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down("smMd"));
  var _React$useState = React.useState(_fillInstanceProperty(_context = Array(NUM_OTP_DIGITS)).call(_context, "")),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    otpValues = _React$useState2[0],
    setOtpValues = _React$useState2[1];
  var inputRefs = useRef([]);
  var clearOtpInputs = function clearOtpInputs() {
    var _context2;
    setOtpValues(_fillInstanceProperty(_context2 = Array(NUM_OTP_DIGITS)).call(_context2, ""));
  };
  var handleBack = function handleBack() {
    clearOtpInputs();
    onBack();
  };
  var handleResend = function handleResend() {
    clearOtpInputs();
    onResendOTP();
  };
  var handleInputChange = function handleInputChange(index, value) {
    if (value.length > 1) {
      return;
    }
    var newOtpValues = _toConsumableArray(otpValues);
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);
    if (value && index < 5) {
      var _inputRefs$current;
      (_inputRefs$current = inputRefs.current[index + 1]) === null || _inputRefs$current === void 0 || _inputRefs$current.focus();
    }
  };
  var handleKeyDown = function handleKeyDown(index, e) {
    if (e.key === "Backspace" && !otpValues[index] && index > 0) {
      var _inputRefs$current2;
      (_inputRefs$current2 = inputRefs.current[index - 1]) === null || _inputRefs$current2 === void 0 || _inputRefs$current2.focus();
    }
  };
  var handlePaste = function handlePaste(e) {
    var _context3, _context4;
    e.preventDefault();
    var pastedData = _trimInstanceProperty(_context3 = e.clipboardData.getData("text")).call(_context3);
    var digits = _sliceInstanceProperty(_context4 = pastedData.replace(/\D/g, "")).call(_context4, 0, 6);
    if (digits.length === 6) {
      var _inputRefs$current$;
      var newOtpValues = digits.split("");
      setOtpValues(newOtpValues);
      (_inputRefs$current$ = inputRefs.current[5]) === null || _inputRefs$current$ === void 0 || _inputRefs$current$.focus();
    }
  };
  var handleSignIn = function handleSignIn() {
    if (loading) return;
    onVerifyOTP(otpValues.join(""));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(WorkplaceOSLoginContainer, {
      children: [/*#__PURE__*/_jsx(WorkplaceOSLoginHeader, {
        title: "Check your email inbox!",
        onBack: handleBack
      }), /*#__PURE__*/_jsxs(Typography, {
        variant: "paragraph_small",
        weight: "regular",
        className: classes.instructionText,
        color: RaiseColors.grayscale900,
        children: ["We need to verify your email address. We've sent a 6-digit code to ", email, ". The code expires in 10 minutes. Please enter it below."]
      }), /*#__PURE__*/_jsx("div", {
        className: classes.otpContainer,
        children: _mapInstanceProperty(otpValues).call(otpValues, function (value, index) {
          return /*#__PURE__*/_jsx(TextField, {
            value: value,
            onChange: function onChange(e) {
              return handleInputChange(index, e.target.value);
            },
            onKeyDown: function onKeyDown(e) {
              return handleKeyDown(index, e);
            },
            className: classes.otpInput,
            InputProps: {
              classes: {
                root: classes.otpInputRoot,
                input: classes.otpInputInner
              },
              inputRef: function inputRef(el) {
                inputRefs.current[index] = el;
              }
            },
            inputProps: {
              maxLength: 1,
              pattern: "[0-9]*",
              inputMode: "numeric",
              onPaste: handlePaste
            },
            disabled: loading
          }, index);
        })
      }), isError && errorMessage && /*#__PURE__*/_jsx("div", {
        className: classes.errorMessage,
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph_small",
          weight: "regular",
          color: RaiseColors.destructive500,
          children: errorMessage
        })
      }), /*#__PURE__*/_jsx("div", {
        className: classes.signInButton,
        children: /*#__PURE__*/_jsx(RaiseButton, {
          variant: ButtonVariantEnum.primary,
          size: isMobile ? ButtonSizeEnum.small : ButtonSizeEnum.large,
          onClick: handleSignIn,
          setToFill: true,
          children: "Sign in"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: classes.resendSection,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "paragraph_small",
          weight: "regular",
          color: RaiseColors.grayscale900,
          className: classes.resendText,
          children: "Didn't receive a code?"
        }), /*#__PURE__*/_jsx(TextLink, {
          onClick: loading ? undefined : handleResend,
          variant: isMobile ? "paragraph_small" : "paragraph_xsmall",
          weight: isMobile ? "regular" : "medium",
          children: isMobile ? "Resend" : "Resend by Email"
        })]
      })]
    }), /*#__PURE__*/_jsx(WorkplaceOSLoginTerms, {})]
  });
};
export default WorkplaceOTPVerification;